// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1_VLm","empty":"ModalGraph_empty__1z6lt"};